export function parseInstantLayout(rawLayout) {
  if (!rawLayout) {
    return null;
  }

  if (typeof rawLayout === 'object') {
    return rawLayout;
  }

  if (typeof rawLayout !== 'string') {
    return null;
  }

  const trimmed = rawLayout.trim();

  if (!trimmed) {
    return null;
  }

  try {
    return JSON.parse(trimmed);
  } catch {
    // Layout may be a legacy/simple token such as "L1", not JSON.
    return {
      rawLayout: trimmed,
      layoutWidth: 0,
      layoutHeight: 0,
      reveals: []
    };
  }
}
